import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { EyeOutlined } from '@ant-design/icons';
import "./EditClass.css";
import CreateClassSidebar from "../../Components/CreateClassSidebar/CreateClassSidebar";
import { message, Spin } from "antd";
import axiosInstance from "../../Config/axiosConfig";
import { useLocation } from 'react-router-dom';

function EditClass() {
  const { classId } = useParams();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false); 
  const [classData, setClassData] = useState(null);
  const [classVideos, setClassVideos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false); // Add submit loading state
  const location = useLocation();
  const { teacherId } = location.state || {};

  useEffect(() => {
    if (classId) {
      setIsEditing(true);
      fetchClassData();
    }
  }, [classId]);

  const fetchClassData = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem("accessToken");
    const storedDeviceId = localStorage.getItem("deviceId");
    const storedUserIp = localStorage.getItem("userIp");

    try {
      if (!classId || typeof classId !== 'string') {
        throw new Error("Invalid Class ID");
      }

      const classResponse = await axiosInstance.get(`/class/get-class/${classId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          UserDevice: storedDeviceId,
          UserIPAddress: storedUserIp,
        },
      });

      if (classResponse.data.code === 200 && classResponse.data.data) {
        setClassData(classResponse.data.data);

        const videoResponse = await axiosInstance.get(`/Video/get-class-videos/${classId}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        });
        
        if (videoResponse.data.code === 200 && videoResponse.data.data) {
          const videosWithTimestamps = videoResponse.data.data.map(video => ({
            ...video,
            created_at: video.created_at || new Date().toISOString()
          }));
          
          setClassVideos({
            videos: videosWithTimestamps
          });
        }
      } else {
        message.error("Failed to fetch class data: " + (classResponse.data?.message || "Unknown error"));
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Error fetching class data: " + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitClass = async () => {
    if (!classId) {
      message.warning("Please save the class before submitting.");
      return;
    }

    const accessToken = localStorage.getItem("accessToken");
    const storedDeviceId = localStorage.getItem("deviceId");
    const storedUserIp = localStorage.getItem("userIp");

    try {
      setSubmitLoading(true);
      
      const response = await axiosInstance.post("/class/submit-for-review/",
        {
          class_id: classId,
          remark: "The video is completed",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        }
      );

      console.log(response.data);

      if (response.data.code === 200) {
        message.success("Class submitted for review successfully!");
      } else {
        message.error("Failed to submit class: " + response.data.message);
      }
    } catch (error) {
      message.error("Error submitting class: " + error.message);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handlePreviewClick = () => {
    if (classId) {
      navigate(`/preview-class/${classId}`);
    } else {
      message.warning("Please save the class before previewing.");
    }
  };

  return (
    <div className="create-class-component">
      <div className="create-class-upper-content">
        <div className="create-class-header-content">
          <span className="create-class-title-text">
            {isEditing ? "Edit Class" : "Create Class"}
          </span>
          <span
            className="create-class-preview-text"
            onClick={handlePreviewClick}
          >
            <EyeOutlined style={{ marginRight: 8 }} />
            Preview Class
          </span>
        </div>
        <div className="create-class-split-button">
          <span 
            className="create-class-button-green" 
            onClick={handleSubmitClass}
            disabled={submitLoading} // Disable button when loading
          >
            {submitLoading ? (
              <>
                <Spin size="small" style={{ marginRight: 8 }} />
                Submitting...
              </>
            ) : "Submit"}
          </span>
        </div>
      </div>

      {loading ? (
        <Spin size="large" />
      ) : (
        <CreateClassSidebar
          teacherId={teacherId.userId}
          classId={classId}
          isEditing={isEditing}
          classData={classData}
          classVideos={classVideos}
        />
      )}
    </div>
  );
}

export default EditClass;